<template lang="pug">
v-content
  v-toolbar.page-header(app, flat, fixed, color='white', height='105')
    v-breadcrumbs(divider='/')
      v-breadcrumbs-item
        router-link(to='/people')
          h2 All People
      v-breadcrumbs-item(v-if='!this.$route.params.id' disabled='')
        h2.ma-0 Add User
      v-breadcrumbs-item(v-if='this.$route.params.id'  disabled='')
        router-link(:to="`/people/person/${this.$route.params.id}`")
          h2.ma-0
            | {{ C.data.person.firstname }} {{ C.data.person.lastname }}
    v-spacer
    v-btn.page-header__action(:to='{name: "PersonEdit", params: { id: this.$route.params.id }}', exact='', color='primary', v-if='this.$route.params.id && (CR.authorization.state.isOrgAdmin || CR.authorization.state.isGod)')
      | Edit

    //- v-breadcrumbs-item(v-if='this.$route.params.id' disabled='')
    //-   h3.ma-0 Edit

  v-container.pa-0(fluid)
    v-layout(row, nowrap)
      v-flex
        .pb-3
          .section__title.mb-5
            .subheading
              | Info
          v-layout(row)
            v-flex(md3)
              label.pl-0 Name
            v-flex(md6)
              p {{ C.data.person.firstname }} {{ C.data.person.lastname }}

          v-layout(row v-if='C.data.person.email')
            v-flex(md3)
              label.pl-0 Email
            v-flex(md6)
              p {{ C.data.person.email }}

          v-layout(row v-if='C.data.person.citizenship')
            v-flex(md3)
              label.pl-0 Citizenship
            v-flex(md6)
              p {{ C.list.countries[C.data.person.citizenship] && C.list.countries[C.data.person.citizenship].name }}

          v-layout(row v-if='C.data.person.time_zone && CR.show.unreleased')
            v-flex(md3)
              label.pl-0 Time Zone
            v-flex(md6)
              p {{ C.data.person.time_zone }}

        .pb-5(v-if='C.data.person.home_address')
          .section__title.mb-5
            .subheading
              | Home Address

          v-layout(row v-if='C.data.person.home_address.street1')
            v-flex(md3)
              label.pl-0 Street Address
            v-flex(md6)
              p
                | {{ C.data.person.home_address.street1 }}
              p(v-if='C.data.person.home_address.street2')
                | {{ C.data.person.home_address.street2 }}

          v-layout(row v-if='C.data.person.home_address.city')
            v-flex(md3)
              label.pl-0 City
            v-flex(md6)
              p {{ C.data.person.home_address.city }}

          v-layout(row v-if='C.data.person.home_address.state_province')
            v-flex(md3)
              label.pl-0 State/Province
            v-flex(md6)
              p {{ C.data.person.home_address.state_province }}

          v-layout(row v-if='C.data.person.home_address.postal_code')
            v-flex(md3)
              label.pl-0 Postal Code
            v-flex(md6)
              p {{ C.data.person.home_address.postal_code }}

          v-layout(row v-if='C.data.person.home_address.country')
            v-flex(md3)
              label.pl-0 Country
            v-flex(md6)
              p {{ C.list.countries[C.data.person.home_address.country] && C.list.countries[C.data.person.home_address.country].name }}

          v-layout(row v-if='C.data.person.home_address.phone_number && (CR.authorization.state.isGod || CR.authorization.state.isOrgAdmin)')
            v-flex(md3)
              label.pl-0 Phone Number
            v-flex(md6)
              p {{ C.data.person.home_address.phone_number }}

        .pb-5(v-if='C.data.person.work_address')
          .section__title.mb-5(v-if='C.data.person.work_address')
            .subheading
              | Work Address

          v-layout(row v-if='C.data.person.work_address.street1')
            v-flex(md3)
              label.pl-0 Street Address
            v-flex(md6)
              p
                | {{ C.data.person.work_address.street1 }}
              p(v-if='C.data.person.work_address.street2')
                | {{ C.data.person.work_address.street2 }}

          v-layout(row v-if='C.data.person.work_address.state_province')
            v-flex(md3)
              label.pl-0 State/Province
            v-flex(md6)
              p {{ C.data.person.work_address.state_province }}

          v-layout(row v-if='C.data.person.work_address.city')
            v-flex(md3)
              label.pl-0 City
            v-flex(md6)
              p {{ C.data.person.work_address.city }}

          v-layout(row v-if='C.data.person.work_address.postal_code')
            v-flex(md3)
              label.pl-0 Postal Code
            v-flex(md6)
              p {{ C.data.person.work_address.postal_code }}

          v-layout(row v-if='C.data.person.work_address.country')
            v-flex(md3)
              label.pl-0 Country
            v-flex(md6)
              p {{ C.list.countries[C.data.person.work_address.country] && C.list.countries[C.data.person.work_address.country].name }}

          v-layout(row v-if='C.data.person.work_address.phone_number && (CR.authorization.state.isGod || CR.authorization.state.isOrgAdmin)')
            v-flex(md3)
              label.pl-0 Phone Number
            v-flex(md6)
              p {{ C.data.person.work_address.phone_number }}


        .pb-5(v-if='C.data.person.organizations && C.data.person.organizations.length > 0')
          .section__title.mb-5
            .subheading
              | Organizations

          v-layout(row, no-wrap, align-center, v-for='organizationStatusItem in C.data.person.user_organization_statuses', :key='organizationStatusItem.organization_id')
            v-flex
              v-card-title.pa-0.pt-2
                h3 {{ organizationStatusItem.organization_name }}
              v-card-text.pl-0.pt-2
                v-layout(row, wrap, align-center)
                  p(v-if='organizationStatusItem.status')
                    label.mr-2
                      | Status:
                    | {{ organizationStatusItem.status }}
                  p(v-if='organizationStatusItem.title && organizationStatusItem.oa')
                    span.px-3 &bull;
                    label.mr-2
                      | Title:
                    | {{ organizationStatusItem.title }}
                  p(v-if='organizationStatusItem.phone && organizationStatusItem.oa')
                    span.px-3 &bull;
                    label.mr-2
                      | Phone:
                    | {{ organizationStatusItem.phone }}
                  p(v-if='organizationStatusItem.oa')
                    span.px-3 &bull;
                    v-icon.mr-1(small, color='secondary') person
                    | Org Admin

</template>

<script>
  import globalSettings from '../../assets/global-settings.js'
  import tools from '../../assets/tools.js'
  import countryData from 'country-data'

  export default {
    data () {
      return {
        CR: {
          show: globalSettings.show,
          authorization: globalSettings.authorization
        },
        C: {
          data: {
            person: {}
          },
          list: {
            countries: countryData.countries
          }
        },
        dialog: false
      }
    },
    created () {
      var component = this

      tools.getUser({
        id: this.$route.params.id,
        success: function (userData) {
          component.C.data.person = userData
        }
      })
    }
  }
</script>


<style scoped lang='scss'>
  .media {
      height: 100%;
      margin: 0;
  }
  .side-drawer {
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/components/People/Person.vue